import VideoPlayer from '@/js/core/VideoPlayer'
import $ from 'jquery'

export default class HeroVisual extends VideoPlayer {
  static OVERLAY_OPEN = 'overlay--open'

  static root = '[data-hero-visual]'
  
  actions = {
    isFullscreen: 'update',
    intersection: 'update',
  }

  selectors = {
    'open': '[data-open-overlay]',
    'video': '[data-video-overlay]',
    'close[]': '[data-close-overlay]',
  }

  listeners = {
    'click @open': () => {
      if ($.device.mobile.phone)
        this.fullscreenRequest(this.$els.video)
      else this.$.body.addClass(HeroVisual.OVERLAY_OPEN)
      this.playVideo()
    },

    'click @close': () => {
      this.$.body.removeClass(HeroVisual.OVERLAY_OPEN)
      this.pauseVideo()
    },
  }

  update () {
    const { isFullscreen } = this.state
    this.$.body &&
    this.$.body[isFullscreen 
      ? 'addClass' 
      : 'removeClass'
    ](HeroVisual.OVERLAY_OPEN)

    if (!isFullscreen) {
      this.pauseVideo()
    }
  }
}